import { type FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useMatch } from "react-router";

import { toSafeInt } from "widgets/utils";

import styleLayout from "../core/styles/PageLayout.module.scss";

import ButtonHeader from "../core/ButtonHeader.js";
import DataTableContainer from "../core/grid/DataTableContainer.js";
import BlastPageHeader from "./BlastPageHeader.js";
import { type BlastJob, type InputTableQuerySpec, type JobResult } from "@/graphql.ts";
import { createUniqueKeyFromTableSpec, ensureRowIsVisible } from "@/redux/modules/table-data.ts";
import { type ReduxDispatch } from "@/redux/redux-utils.ts";
import { BLAST_SUB_VIEW, DATATABLE_ID_TYPE, ENTITY_TYPE, VIEW } from "@/settings/settings.js";

interface IBlastResultHitsTableViewOwnProps {
  job: BlastJob;
  jobResult?: JobResult;
  viewId?: number;
  isLoading?: boolean;
}

const BlastResultHitsTableView: FC<IBlastResultHitsTableViewOwnProps> = (props) => {
  const dispatch = useDispatch<ReduxDispatch>();
  const match = useMatch("/job/:jobId/results/:queryId/hits/:hitNum");
  const hitNum = match?.params.hitNum;
  const [tableSpec, setTableSpec] = useState<InputTableQuerySpec>();

  useEffect(() => {
    if (props.jobResult) {
      setTableSpec({
        pagination: undefined,
        restrictions: undefined,
        resultSubTypeId: undefined,
        rowFilter: "",
        rowSorting: "",
        id: props.jobResult.id,
        idType: DATATABLE_ID_TYPE.ENTITY,
        queryType: ENTITY_TYPE.QUERY,
        resultType: ENTITY_TYPE.BLAST_HIT,
      });
    }
  }, [props.jobResult]);

  useEffect(() => {
    if (tableSpec && hitNum) {
      dispatch(ensureRowIsVisible(tableSpec, null, toSafeInt(hitNum) - 1));
    }
  }, [dispatch, hitNum, tableSpec]);

  return (
    <>
      <BlastPageHeader
        job={props.job}
        jobResult={props.jobResult}
        subtitle={"Hits"}
        actionWidgets={[
          tableSpec && (
            <ButtonHeader
              viewType={VIEW.TABLE_VIEW.type}
              subViewType={BLAST_SUB_VIEW.HITS}
              tableSpec={tableSpec}
              hideBlastBtn
              key={"blast=result-hits-table-view-action-1"}
            />
          ),
        ]}
        isLoading={props.isLoading}
      />
      <div className={styleLayout.page} style={{ backgroundColor: "white" }}>
        {tableSpec && (
          <DataTableContainer
            key={createUniqueKeyFromTableSpec(tableSpec)}
            tableSpec={tableSpec}
            viewId={props.viewId}
          />
        )}
      </div>
    </>
  );
};

export { BlastResultHitsTableView };
